import GenericRowEditAndDeleteModal from 'components/icons/GenericRowEditAndDeleteModal';

export const columnsDataMercado = [
	{
		Header: ' ',
		accessor: 'CheckBox',
		disableSortBy: true,
		type: 'checkBox',
		filter: false,
	},
	{
		Header: 'Mercado',
		accessor: 'nome_mercado',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
		hover: 'Nome do mercado',
	},
	{
		Header: ' ',
		type: 'jsx',
		accessor: 'button',
		jsx: GenericRowEditAndDeleteModal,
		filter: false,
	},
];
